<template>
  <div
    class="relative mb-8 text-center mobile:mx-2"
    :data-ab-id="dataAbId"
  >
    <h2
      v-if="title"
      :style="{ color: titleColorHex }"
    >
      {{ title }}
    </h2>
    <p
      v-if="subTitle"
      class="text-sm"
      :style="{ color: subtitleColorHex }"
    >
      {{ subTitle }}
    </p>
    <div class="my-3 flex justify-center">
      <p class="inline-block h-px w-full max-w-[130px] bg-neutral-100 desktop:max-w-[300px]" />
    </div>
    <div
      v-if="tilesItems?.length > 0"
      class="flex flex-wrap justify-center gap-2 desktop:gap-5"
    >
      <SharedLink
        v-for="(item, index) in tilesItems"
        :key="index"
        :link="item.link"
        :class="{ 'shadow-default': !disableShadow }"
        :style="{ 'background-color': item.backgroundColor }"
        class="relative"
      >
        <NuxtImg
          :src="item.src"
          :alt="item.alt"
          sizes="lg:100vw 48vw"
          :srcset="item.srcset"
          :loading="imageLoadType"
          :preload="imageLoadType === 'eager'"
          :fetchpriority="imageLoadType === 'eager' ? 'high' : 'low'"
          class="size-[112px] object-contain desktop:size-[188px]"
        />
      </SharedLink>
    </div>
  </div>
</template>

<script lang="ts" setup>
import magnoliaGetters from '~/composables/getters/magnoliaGetters';

interface Props {
  title?: string;
  titleColor?: number;
  subTitle?: string;
  subtitleColor?: number;
  disableShadow?: boolean;
  items?: any[];
  imageLoadType?: HTMLImageElement['loading'];
  dataAbId?: string;
}

const props = withDefaults(defineProps<Props>(), {
  items: () => [],
  imageLoadType: 'lazy',
  disableShadow: false,
});

const { $domain } = useNuxtApp();

const titleColorHex = magnoliaGetters.getHexColor(props.titleColor);
const subtitleColorHex = magnoliaGetters.getHexColor(props.subtitleColor);

const tilesItems = computed(() => {
  return props.items?.map((item) => {
    return {
      src: magnoliaGetters.getDefaultSrcAsset(item.image, $domain.cmsAssetDomainPath),
      srcset: magnoliaGetters.getSrcSetImagesAsString(item.image, $domain.cmsAssetDomainPath, item.aspectRatio, item.mobileAspectRatio?.[0]?.aspectRatio, item.mobileImage?.[0]?.image),
      link: item.imageLink?.[0] ? magnoliaGetters.getLinkAndName(item.imageLink[0], $domain.cmsAssetDomainPath) : {},
      title: magnoliaGetters.getTitleImage(item.image, item.imageTitle),
      alt: magnoliaGetters.getAltImage(item.image, item.alt),
      backgroundColor: magnoliaGetters.getHexColor(item.backgroundColor),
    };
  });
});
</script>
